export enum ACTIVE_TAB_POPUP {
    MESSAGE = 'message',
    SETTING = 'settings'
}

export enum SHOWING_MODE {
    PERSISTENT = 'persistent',
    COMMON = 'common',
    HIDDEN = 'hidden'
}

export enum ROLE_MODE {
    ADMIN = 'admin'
}
